import { parsePrice } from "helpers/price";
import { HorizontalLine } from "pages/Dashboard/components/styled";
import { RadioButton } from "primereact/radiobutton";
import styled from "styled-components";

import { BenefitLine } from "./BenefitLine";

const coverageColor: any = {
  COVERED: "text-green-500",
  NON_COVERED: "text-red-500",
  UNKNOWN: "text-orange-500",
};

const StyledRadioButton = styled(RadioButton)`
  .p-radiobutton-box {
    width: 18px;
    height: 18px;
  }
  .p-radiobutton-box .p-radiobutton-icon {
    width: 10px;
    height: 10px;
  }
`;

export function ValueNoteSection({
  title,
  items,
  className,
  serviceCoverage,
  selectable,
  onSelect,
  selected,
  alignWithRadio,
}: {
  title: string;
  items: {
    Notes?: string | null;
    Value?: string | null;
    name?: string | null;
    subtitle?: string | null;
    additionalCopay?: any | null;
    additionalCoinsurance?: any | null;
    CoverageLevel?: "Individual" | "Family";
    dates?: { Date?: string | null; Type?: string | null }[];
  }[];
  className?: string;
  serviceCoverage?: string;
  selectable?: boolean;
  onSelect?: (value: string, name: string) => void;
  selected?: string | null;
  alignWithRadio?: boolean;
}) {
  if (!items.length) {
    return null;
  }
  return (
    <div className="flex flex-column gap-2 pt-1">
      {items.map((item, index) => (
        <div
          className="flex flex-column gap-2"
          key={`${title}_${item.subtitle}_${index}`}
        >
          <div className="flex w-full items-center">
            {selectable && onSelect ? (
              <StyledRadioButton
                inputId={title}
                name={title}
                value={item.Value}
                className="ml-3"
                onChange={(e) => onSelect(e.value, item.name || "")}
                checked={selected === item.name}
              />
            ) : (
              alignWithRadio && <div className="ml-3" style={{ width: 22 }} />
            )}
            <BenefitLine
              title={`${title} ${item.subtitle || ""}`}
              note={item.Notes}
              value={item.Value}
              dates={item?.dates}
              coverageLevel={item.CoverageLevel}
              showSelected={selectable && onSelect && selected === item.name}
            />
          </div>
          <HorizontalLine marginTop="5px" marginBottom="5px" />
          {item?.additionalCopay?.map((copay: any, index: number) => (
            <>
              <BenefitLine
                key={`${index}_additionalCopay`}
                title={`${title} Additional Copay`}
                value={
                  copay.monetaryAmount
                    ? parsePrice(Number(copay.monetaryAmount))
                    : "N/A"
                }
                messages={copay.messages}
                {...(title === "Physician Outpatient" && {
                  networkIndicator: copay.networkIndicator,
                  coverageLevel: copay.coverageLevel,
                  timePeriodQualifier: copay.timePeriodQualifier,
                })}
                benefitEntities={copay.benefitEntities}
              />
              <HorizontalLine marginTop="5px" marginBottom="5px" />
            </>
          ))}
          {item?.additionalCoinsurance?.map(
            (coinsurance: any, index: number) => (
              <>
                <BenefitLine
                  key={`${index}_additionalCoinsurance`}
                  title={`${title} Additional Coinsurance`}
                  value={coinsurance.percent ? `${coinsurance.percent}` : "N/A"}
                  isCoinsurance
                  messages={coinsurance.messages}
                  benefitEntities={coinsurance.benefitEntities}
                  {...(title === "Physician Outpatient" && {
                    networkIndicator: coinsurance.networkIndicator,
                    coverageLevel: coinsurance.coverageLevel,
                    timePeriodQualifier: coinsurance.timePeriodQualifier,
                  })}
                />
                <HorizontalLine marginTop="5px" marginBottom="5px" />
              </>
            )
          )}
        </div>
      ))}
      {serviceCoverage && (
        <p className="text-sm px-4">
          Service Coverage:{" "}
          <span className={coverageColor[serviceCoverage]}>
            {serviceCoverage === "NON_COVERED"
              ? "NON COVERED"
              : serviceCoverage}
          </span>
        </p>
      )}
    </div>
  );
}
